export default __webpack_public_path__ + "static/america-icon-f95ab9b5e2c64c6c23fcf2c483ca82f0.svg";